<div class="container my-4 pb-4" *ngIf="!errorview && !lockedview">

    <!--------------------->
    <!---- Descripcion ---->
    <!--------------------->
    <app-driver-description 
        [postSign]="postSign" 
        [driverSignerData]="driverSignerData">
    </app-driver-description>

    <!--------------------->
    <!------ Grilla ------->
    <!--------------------->
    <div *ngIf="!postSign">
        <div class="table-container mb-4">
            <app-dynamic-table 
                [hideSelection]="true" 
                [columnNames]="columnsConfig$ | async" 
                [tableData]="documents">
            </app-dynamic-table>
        </div>
    </div>

    <!---------------------->
    <!------ Botonera ------>
    <!---------------------->
    <div *ngIf="postSign"
    class="action-btns d-flex flex-column pl-md-3 flex-md-row justify-content-md-between">
        <button type="button" class="btn btn-success mb-2 mb-md-0 icon-btn" (click)="this.download()">
            <span>{{'table.buttons.download' | translate}}</span>
            <span class="material-icons">get_app</span>
        </button>
        <button type="button" class="btn btn-success ml-md-3 mb-2 mb-md-0 icon-btn" (click)="this.email()">
            <span>{{'table.buttons.email' | translate}}</span>
            <span class="material-icons">email</span>
        </button>
        <button type="button" class="btn btn-success ml-md-3 mb-2 mb-md-0 icon-btn" (click)="this.print()">
            <span>{{'table.buttons.print' | translate}}</span>
            <span class="material-icons">print</span>
        </button>
    </div>

    <!---------------------------->
    <!-- Panel Driver Signature -->
    <!---------------------------->
    <div *ngIf="!postSign">
        <app-driver-signature
        [signList]="signList"
        (sendSign)="this.signDocuments($event)">
        </app-driver-signature>
    </div>

    <!--------------------------------->
    <!-- Panel Destination Signature -->
    <!--------------------------------->
    <div *ngIf="postSign && !isTenarisDestination && !externalPostSign">
        <app-destination-signature
            [signList]="signList"
            (sendSign)="this.signDocuments($event)">
        </app-destination-signature>
    </div>
    
    <!---------------------->
    <!------ Vista PDF ----->
    <!---------------------->
    <div class="doc-container" #container>
        <ng-container *ngFor="let d of pdfs">
            <!-- <pdf-viewer 
                [src]="d.pdf" 
                [autoresize]="true" 
                [original-size]="true" 
                [fit-to-page]="true"
                [show-borders]="true" 
                [render-text]="true" 
                style="display: block;">
            </pdf-viewer> -->
             <pdf-viewer
            *ngIf="d.pdf"
             [src]="d.pdfPreview" [autoresize]="true" [original-size]="true" [fit-to-page]="true"
             [show-borders]="false" [render-text]="true" 
            style="display: block; width: 100%; height:800px;">
            </pdf-viewer>
        </ng-container>
    </div>

</div>

<!---------------------->
<!------- Modales ------>
<!---------------------->
<app-mail-sender #mailSender [loading]="loading" (onSend)="sendDocs($event)"></app-mail-sender>

<iframe #iframe width="420" height="345" [src]="pdfToPrint | safe"></iframe>

<!-------------------------->
<!------- Vista error ------>
<!-------------------------->
<div class="container my-4 pb-4" *ngIf="this.errorview">
    <div class="alert alert-primary" role="alert">
        {{'sign.driver_data.error_view' | translate}}
    </div>
</div>

<!---------------------------->
<!------- Vista bloqueo ------>
<!---------------------------->
<div class="container my-4 pb-4" *ngIf="this.lockedview">
    <div class="alert alert-primary" role="alert">
        {{'sign.driver_data.locked_view' | translate}}
    </div>
</div>